import script from "./dvhc-xa.vue?vue&type=script&setup=true&lang=js"
export * from "./dvhc-xa.vue?vue&type=script&setup=true&lang=js"

import "./dvhc-xa.vue?vue&type=style&index=0&id=0e981875&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e981875"]])

export default __exports__